import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { AccountingPaymentBulkAccountsRecievableActions } from ".";
import { IAccountingPaymentBulkAccountsRecievableState, initialAccountingPaymentBulkAccountsRecievableState } from "./PaymentBulkAccountsRecievable.types";
import { FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_FAILURE, FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_PROGRESS, FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_SUCCESS } from "./PaymentBulkAccountRecievableActions";

export const AccountingPaymentBulkAccountsRecievableReducer = (
  state: IStoreState["accounting"]["paymentBulkAccountsRecievable"] = initialAccountingPaymentBulkAccountsRecievableState,
  action: AccountingPaymentBulkAccountsRecievableActions
) => {
  switch (action.type) {
    case FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.bulkPayment.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.bulkPayment.loading = LoadState.Loaded;
        draftState.bulkPayment.data = data;
      });
      return newState;
    }
    case FETCH_ACCOUNTING_PAYMENT_BULK_ACCOUNTS_RECIEVABLE_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState: IAccountingPaymentBulkAccountsRecievableState) => {
        draftState.bulkPayment.loading = LoadState.Failed;
        draftState.bulkPayment.error = errorMessage;
      });
      return newState;
    }
    default:
      return state;
  }
};